export const ENERGIZER_DESCRIPTION =
  'Re-energize your class with fun and easy energizers to keep your class motivated and engaged throughout the lesson.';
